import React from "react";
import isEmpty from "lodash/isEmpty";
import { ResponsiveHeroImage } from "@quintype/components";
import { StoryHeaderCard } from "../story-page-components/story-header-card.js";
import { StoryPageCard } from "../story-page-components/story-page-card.js";
import { LiveBlogKeyEvents } from "../story-page-components/live-blog-key-events.js";
import TimeAgo from 'react-timeago';
import {format} from "date-fns";
import { MetypeCommentingWidget } from "@metype/components";
import { breakpoint } from "../../../utils/breakpoint";
import { addTargetBlankToExtLinks } from "../../../utils/add-target-blank-to-extlinks";
import { altTagOfHeroImages} from "../../utils";
import { ImageFallback } from "../basic/image-fallback.js";

class LiveBlogTemplate extends React.Component {

  constructor(props){
    super(props);
    const {config: {'metype-config':metypeConfig = {}, 'cdn-image':cdnImage = ''} = {}} = this.props;
    this.metypeConfig = metypeConfig;
    this.cdnImage = cdnImage;
  }

  formatter(value, unit, suffix, date, defaultFormatter) {
    return format(new Date(date), 'DD MMM, HH:MM A');
  }

  generateHostUrl(story = {}){
    if(global.location){
      return `${global.location.origin}/${story.slug}`;
    }
  }

  loadWidget(){
    if(this.props.preview || isEmpty(this.metypeConfig)) {
      return null;
    }
    return (<MetypeCommentingWidget
      host={this.metypeConfig.host}
      accountId={this.metypeConfig.accountId}
      pageURL={this.generateHostUrl(this.props.story)}
      primaryColor={this.metypeConfig.primaryColor} />);
  }
  hideBrokenImg(ev) {
      ev.target.style.display="none";
      ev.currentTarget.style.padding="10px";

    }
  render(){
    return (
    <article className="live-blog-story blank-story">
      <figure  onError={(ev) => this.hideBrokenImg(ev)} className="live-blog-story-hero-image blank-story-hero-image qt-image-16x9">
        { breakpoint('tablet') ?
          <ResponsiveHeroImage story={this.props.story}
           aspectRatio={[16,9]}
           alt={altTagOfHeroImages(this.props.story)}
           defaultWidth={480} widths={[250,480,640]} sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
           imgParams={{auto:['format', 'compress'], fit:'max'}} /> :
           <ResponsiveHeroImage story={this.props.story}
           aspectRatio={[9,3]}
          alt={altTagOfHeroImages(this.props.story)}
           defaultWidth={480} widths={[250,480,640,960,1200]} sizes="(max-width: 500px) 98%"
           imgParams={{auto:['format', 'compress'], fit:'max'}} />
        }
      </figure>
      <div className={`live-blog-story__extra-wrapper`}>
        <div className="live-blog-story--wrapper blank-story--wrapper">
          <StoryHeaderCard story={this.props.story} config={this.props.config}/>
        </div>
        <LiveBlogKeyEvents story={ this.props.story } />
        <div className="live-blog-story--wrapper blank-story--wrapper">
          <div className="live-blog-story--content blank-story--content">
            {this.props.story.cards.map((card, index) => <div className="story-cards" id={card.id} key={index}>
              <TimeAgo date={card['card-added-at']}  className="card-added-at" formatter={this.formatter}/>
              <StoryPageCard key={index} card={card} story={this.props.story} cdn={this.cdnImage}/>
              <p className="card-updated-at">Last updated <TimeAgo date={card['card-updated-at']}/></p>
                {((this.props.story.cards.length - 1) === index) && this.loadWidget()}
            </div>)}
          </div>
        </div>
      </div>
    </article>
    );
  }
}

class LiveBlogStory extends React.Component {
  componentDidMount() {
    addTargetBlankToExtLinks(this.storyWrapperElement)
  }
  render() 
  {
    return <div className={`story-grid`} ref={(el) => this.storyWrapperElement = el}>
      <LiveBlogTemplate {...this.props}></LiveBlogTemplate>
    </div>
  }
}

export { LiveBlogStory };
